import { CertificatoUnioneCivileList, SectionVM } from 'civil-status/view-models/step-form';
import { ID_ALTRO_COMUNE } from 'shell/components/shared/municipality-list';

export const transformerCertificatoUnioneCivileList = (
  dataCertCivilUnionList?: Array<SectionVM>
): Array<CertificatoUnioneCivileList> | undefined => {
  const dataList = dataCertCivilUnionList || [];

  if (dataList.length === 0) {
    return undefined;
  }

  return dataList.map((itemSection) => {
    const isOtherMunicipality =
      itemSection.italian?.municipality?.code?.toString() === ID_ALTRO_COMUNE;

    return {
      key: {
        idCertificatoUnioneCivile: itemSection.idCertificatoUnioneCivile || undefined,
      },
      dataRichiestaCostituzione: itemSection.dateIncorporationCertificate
        ? itemSection.dateIncorporationCertificate?.toFormat('yyyy-MM-dd')
        : undefined,
      idComune: itemSection.italian?.municipality?.code?.toString()
        ? Number.parseInt(itemSection.italian?.municipality?.code.toString(), 10)
        : undefined,
      nomeComune: isOtherMunicipality
        ? itemSection.italian?.otherMunicipality || undefined
        : itemSection.italian?.municipality?.description,
      idProvincia: itemSection.italian?.municipality?.idProvince || undefined,
      siglaProvincia: itemSection.italian?.municipality?.province || undefined,
      tipoSezione: itemSection.typePersistence || undefined,
    };
  }) as Array<CertificatoUnioneCivileList>;
};
